import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';  <-- DELETE THIS LINE
import FairRateHomepage from './FairRateHomepage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <FairRateHomepage />
  </React.StrictMode>
);